module.exports = __webpack_public_path__ + "static/media/internet-of-things08.df12730c.jpg";